// src/components/auth/ProtectedRoute.jsx
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

export default function ProtectedRoute({ requiredRole }) {
  const { currentUser, userRole } = useAuth();
  const location = useLocation();

  if (!currentUser)
    return <Navigate to="/login" state={{ from: location }} replace />;

  if (requiredRole && userRole !== requiredRole)
    return <Navigate to="/dashboard" replace />;

  return <Outlet />;
}
